import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ValueDescription } from '../../../../../card/value-description/value-description';
import Skeleton from '../../../../skeleton';
import { CardTitle } from '../../../../../card/title/card-title';

export const SkeletonDashboardCardsFees: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <div className="relative flex h-full flex-col justify-between overflow-hidden rounded-large bg-body p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:bg-[url('/images/card-stats/fees-bg.svg')] max-md:bg-[length:auto_10rem] max-md:bg-[position:100%_100%] max-md:bg-no-repeat xl:bg-[url('/images/card-stats/fees-bg.svg')] xl:bg-[length:auto_10rem] xl:bg-[position:100%_100%] xl:bg-no-repeat">
            <CardTitle
                title={<div className="text-[#ff697b]">{t('layout.statisticsCard.fees.title')}</div>}
                actions={<Skeleton height={2.4} width={4} variant="negative" radius={20} />}
            />
            <ValueDescription
                value={<Skeleton height={2.4} variant="negative" />}
                description={<Skeleton height={1.3} variant="negative" />}
                padding={'none'}
                valueColor={'default'}
                descriptionColor={'default'}
            />
        </div>
    );
});
